import { dispatchEventObj } from 'a/actions/searchlightActionCreators';

import { REDUX_ACTIONS, ERROR_STRINGS } from './constants';

export const createActionObj = (type, payload) => ({
  type, payload,
});

export const resetAquaError = () =>
  createActionObj(REDUX_ACTIONS.RESET_AQUA_ERROR, {});

/**
 * Throw up the Aqua error screen with custom content — leave argument empty to throw default error
 * @param {*} payload = {
 *  titleText: <String> Text to show in the top portion of the screen,
 *  secondaryText: <String> Subtext to show below the top title text on the screen,
 *  showGamesButton: <Bool> Whether the goto games button should be shown
 *  showHomeButton: <Bool> Whether the goto home button should be shown
 *  forceLogout: <Bool> Whether the user should be forced to login again after pressing either button.
 * }
 */
export const throwCustomAquaError = (payload = {}) => createActionObj(REDUX_ACTIONS.THROW_CUSTOM_AQUA_ERROR, payload);

/**
 * Thunk that shows the standard global error screen ("Uh oh!" / "Something went wrong.").
 * @param {string} errorName
 * @param {string} errorMessage
 */
export const showStandardErrorPage = (errorName, errorMessage) => (dispatch) =>
  dispatch(throwCustomAquaError({
    titleText: ERROR_STRINGS.uhOh, // 'Uh oh!'
    secondaryText: ERROR_STRINGS.theresBeenAnError, // 'Something went wrong.'
    showGamesButton: false,
    showHomeButton: true,
    forceLogout: false,
    errorName,
    errorMessage,
  }));

export const getErrorActionObject = (gameId, error, category, data, metricId) =>
  dispatchEventObj({
    application: {
      gameId,
      eventType: 'ERROR',
      details: {
        category,
        error,
        data,
      },
    },
    log: {
      level: 'error',
      logType: 'communication',
      message: `${category} | ${error}`,
    },
    metric: {
      type: 'count',
      id: `amplify.AQUA.App.error.javascript${metricId !== 'javascript' ? `.${metricId}` : ''}`,
      value: 1,
    },
  });

export const logErrorToSearchlight = (error, info = {}) => (dispatch, getState) => {
  const errorStr = error.toString();
  const { selectedActivity: { activity }, globalErrorReducer } = getState();
  const { category, metricId, data = info.componentStack } = globalErrorReducer;
  dispatch(getErrorActionObject(activity, errorStr, category, data, metricId));
};

export const setIsShowingErrorScreen = () => dispatch =>
  dispatch(createActionObj(REDUX_ACTIONS.SET_IS_SHOWING_ERROR_SCREEN, true));
